module.exports = __webpack_public_path__ + "static/img/szafa_dso_50.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/szafa_dso_50.svg
// module id = 6nsa
// module chunks = 0